import React, { useState, useEffect, useRef } from "react";
import { Col } from "antd";
import { useTranslation } from "react-i18next";

import { DownloadIcon, NoDataIcon } from "icons";
import { generateImg } from "utils";

import {
  BoxHeader,
  BoxTitle,
  LightDivider4Chart,
  BoxContent4Chart,
  WrapperLegend,
  YellowRectangle,
  BlueRectangle,
  SilverRectangle,
  BoxItem4DisorderChart,
} from "../Dashboard.style";
import PieChart from "./PieChart";

const COLORS = ["#E0E0E0", "#EBC300", "#2F8CAE"];

const PhysicalDisorder = ({ data }: any) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "dashboard",
  });
  const { t: t1 } = useTranslation("translation", {
    keyPrefix: "questions",
  });

  const imgRef = useRef<any>();
  const [dataChart, setDataChart] = useState<any>([]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setDataChart([
        { value: data.unanswerd },
        { value: data.physical_problem },
        { value: data.physical_normal_condition },
      ]);
    }
  }, [data]);

  return (
    <Col xs={24} md={12} xl={6} ref={imgRef}>
      <BoxItem4DisorderChart>
        <BoxHeader>
          <BoxTitle>{t("physical-disorder-label")}</BoxTitle>
          <DownloadIcon
            fill="#3B3B3B"
            style={{ marginTop: 4, cursor: "pointer" }}
            onClick={(event: any) => {
              if (!event.detail || event.detail == 1) {
                generateImg("physical-disorder", imgRef.current);
              }
            }}
          />
        </BoxHeader>
        <LightDivider4Chart />
        <BoxContent4Chart>
          {dataChart.length ? (
            <React.Fragment>
              <PieChart data={dataChart} colors={COLORS} />
              <WrapperLegend style={{ marginTop: 7, marginBottom: 3 }}>
                <BlueRectangle />
                <p>
                  {t("no-physical-disorder")}
                  <span>{data?.physical_normal_condition || 0}%</span>
                </p>
              </WrapperLegend>
              <WrapperLegend style={{ marginBottom: 3 }}>
                <YellowRectangle />
                <p>
                  {t("have-physical-disorder")}
                  <span>{data?.physical_problem || 0}%</span>
                </p>
              </WrapperLegend>
              <WrapperLegend>
                <SilverRectangle />
                <p>
                  {t1("unanswered")}
                  <span>{data?.unanswerd || 0}%</span>
                </p>
              </WrapperLegend>
            </React.Fragment>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 17,
              }}
            >
              <NoDataIcon />
            </div>
          )}
        </BoxContent4Chart>
      </BoxItem4DisorderChart>
    </Col>
  );
};

export default PhysicalDisorder;
